/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowParallelHIcon20Regular = forwardRef('ArrowParallelHIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M12.106 2.18a.75.75 0 1 1 1.061-1.06l3.273 3.273c.75.75.75 1.967 0 2.718l-3.273 3.273a.75.75 0 0 1-1.06-1.06l2.82-2.822H3.75a.75.75 0 1 1 0-1.5h11.178L12.106 2.18Z" }),
        React.createElement("path", { d: "M7.894 10.68a.75.75 0 1 0-1.061-1.062L3.56 12.891c-.75.75-.75 1.968 0 2.718l3.273 3.273a.75.75 0 1 0 1.06-1.06L5.074 15H16.25a.75.75 0 1 0 0-1.5H5.072l2.822-2.82Z" })));
});
